function f(f,o,i,a){f._m(o),f.o(o,"Col",()=>f.f(c)),f.o(o,"Row",()=>f.f(d));var c=f.i(i("70f24fd7")),d=f.i(i("dc6a4408"));}